import { FC } from 'react';
import { Languages, useLanguageStore } from '../../../../../../hooks';
import { Radio } from 'antd';
import languageSvg from './language.svg';
import useI18n from '../../../../../../hooks/useI18n';
import { languagesSwitch } from '../../service';
import useUrlState from '@ahooksjs/use-url-state';

export interface ILanguageSettingProps {}

export const LanguageSetting: FC<ILanguageSettingProps> = (props) => {
  console.log(props);
  const { lang, changeLanguage } = useLanguageStore();
  const [urlLang, setUrlLang] = useUrlState({ lang: undefined });
  const i18n = useI18n();

  const switchLanguage = async (lang: Languages) => {
    await languagesSwitch({ lang });
    changeLanguage(lang);
    setUrlLang({
      lang: undefined,
    });
  };
  return (
    <div className="text-[#04252B] px-4 py-3 flex justify-between items-center ml-2 my-3">
      <div className="flex">
        <img src={languageSvg} alt="" />
        <span className="text-sm mx-2">{i18n('languageSet')}</span>
      </div>
      <Radio.Group
        className=""
        onChange={(v) => switchLanguage(v.target.value)}
        value={lang}
      >
        <Radio value={Languages.zh}>简体中文</Radio>
        <Radio value={Languages.en}>English</Radio>
      </Radio.Group>
    </div>
  );
};
